import React, { useEffect, useState } from "react";
import { Button, Breadcrumb, Card, CardBody, CardHeader, Col, Container, Form, Row, Stack, FormSelect, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import PubSub from "pubsub-js";
import Select from "react-select";

import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import CityState from "../../constants/CityState.json";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import * as Constant from "../../constants/CONSTANT";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import PERMISSIONS from "../../constants/permissions";

const OrderAmcEdit = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [showLostModal, setShowLostModal] = useState(false);
    // Define initial errors i.e. required field and their message
    const initialErrors = {
        order_id: { message: validationMessages.orderName.required },
        phone: { message: validationMessages.phone.required },
        owner_ids: { message: validationMessages.ownerId.required },
        amc_status: { message: validationMessages.status.required },
    };
    const userInfo = getUserDetails();
    // Updaed Imran Khan on 07-04-2026 to set Jitendra Choudhary as default owner for all AMC's as per discussion with management and also added current login user as owner by default when order is selected for AMC creation
    const JITENDRA_USER = {
        value: "d57df521-502c-403c-868e-ac3edb86a789",
        label: "Jitendra Choudhary",
    };

    const initialValues = {
    owner_ids: (() => {
        if (userInfo?.id === JITENDRA_USER.value) {
        return [JITENDRA_USER];
        }
        return [
            { value: userInfo?.id, label: userInfo?.username },
            JITENDRA_USER,
        ];
    })(),
        is_gst: "Yes",
        city: "Jaipur",
    };

    // Handle City & state values
    const [states, setStates] = useState([
        ...new Set(CityState.map((item) => item.state)),
    ]);

    const [segmentOptions, setSegmentOptions] = useState(Constant?.SegmentOptions);//Added by shahir hussain for segment type field 02-02-2025

    // orderAmc state
    const [orderAmc, setOrderAmc] = useState(location.state ? location.state : initialValues);

    //errors state
    const [errors, setErrors] = useState(!location.state ? initialErrors : {});
    // useEffect(() => { console.log('errors', errors) }, [errors]);

    // validation state
    const [validated, setValidated] = useState(false);

    // offer state
    const [orders, setOrders] = useState([]);

    // lead state
    const [leads, setLeads] = useState([]);

    // assign users state
    const [assignUsers, setAssignUsers] = useState([]);
    useEffect(() => {
        async function init() {
            if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
            })) {
                const fetchedOrders = await fuziElevatorsApi.fetchOrdersForOrderAMC();
                console.log('fetchedOrders', fetchedOrders);
                Array.isArray(fetchedOrders) && setOrders(fetchedOrders?.map((fetchedOrder) => ({ id: fetchedOrder?.id, name: `${fetchedOrder?.offer_name_label || ""}`, orderData: fetchedOrder })));
            }
            if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_LEAD].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
            })) {
                const fetchedLeads = await fuziElevatorsApi.fetchLeads();
                console.log('fetchedLeads', fetchedLeads);
                Array.isArray(fetchedLeads) && setLeads(fetchedLeads?.map((fetchedLead) => ({ id: fetchedLead?.id, name: `${fetchedLead?.lead_name || ""}` })));
            }
            if ([PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_USER].some(permission => {
                return userInfo?.permissions?.map(p => p.name).includes(permission);
            })) {
                const resultedUsers = await fuziElevatorsApi.fetchUsers();
                (resultedUsers && Array.isArray(resultedUsers)) && setAssignUsers(resultedUsers);
            }
        }
        init();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        // console.log(e.target);
        if (name == "order_id") {
            if (value == "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.orderName.required } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name == "amc_status") {
            if (value == "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.status.required } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }

            // if status is lost, then set is_lost to true
            if (value == "Lost") {
                setOrderAmc((prev) => ({ ...prev, is_lost: true, lost_date: new Date() }));
                setShowLostModal(true);
            }
        }
        else if (name == "email") {
            if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.email.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name === "phone") {
            if (value === "") {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.required } }));
            } else if (e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.phone.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name == "whatsapp_no") {
            if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.whatsappNumber.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name == "owner_ids") {
            if (!value?.length) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.ownerId.required } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        }
        else if (name == "pincode") {
            if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
                setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.pinCode.invalid } }));
            } else {
                setErrors((prev) => {
                    delete prev[name];
                    return { ...prev };
                });
            }
        } else if (name === "segment") {//Added by shahir hussain for segment type field 02-02-2025
            const values = Array.isArray(value)
                ? value?.map((item) => item?.value)
                : [];

            const segmentString = values.join(",");

            setOrderAmc((prev) => ({
                ...prev,
                segment: segmentString,
            }));

            // validation
            // if (values?.length === 0) {
            //   setErrors((prev) => ({
            //     ...prev,
            //     segment: { message: validationMessages.segment.required },
            //   }));
            // } else {
            //   setErrors((prev) => {
            //     delete prev.segment;
            //     return { ...prev };
            //   });
            // }

            setValidated(true);
            return;
        }
        setValidated(true);
        setOrderAmc((prev) => ({ ...prev, [name]: value }));
    };

    // field validators
    const checkRequiredFields = () => {
        let isError = false;

        if (orderAmc?.order_id) {

            if (orderAmc?.order_id == "") {
                setErrors((prev) => ({ ...prev, 'order_id': { message: validationMessages.orderName.required } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['order_id'];
                    return { ...prev };
                });
            }

        }

        if (orderAmc?.amc_status) {

            if (orderAmc?.amc_status == "") {
                setErrors((prev) => ({ ...prev, 'amc_status': { message: validationMessages.status.required } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['amc_status'];
                    return { ...prev };
                });
            }

        }

        if (orderAmc?.email) {
            if (orderAmc?.email != "" && regExPattern?.email && (!RegExp(regExPattern.email).test(orderAmc.email))) {
                setErrors((prev) => ({ ...prev, 'email': { message: "Please provide Valid Email." } }));
                isError = true;

            } else {
                setErrors((prev) => {
                    delete prev['email'];
                    return { ...prev };
                });
            }
        }

        if (orderAmc?.phone) {
            if (orderAmc?.phone == "") {
                setErrors((prev) => ({ ...prev, 'phone': { message: "Please provide phone." } }));
                isError = true;
            } else if (regExPattern?.phone && (!RegExp(regExPattern.phone).test(orderAmc.phone))) {
                setErrors((prev) => ({ ...prev, 'phone': { message: "Please provide Valid phone." } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['phone'];
                    return { ...prev };
                });
            }
        }

        if (orderAmc?.whatsapp_no) {
            if (orderAmc?.whatsapp_no != "" && regExPattern?.phone && (!RegExp(regExPattern.phone).test(orderAmc.whatsapp_no))) {
                setErrors((prev) => ({ ...prev, 'whatsapp_no': { message: "Please provide Valid whatsapp number." } }));
                isError = true;

            } else {
                setErrors((prev) => {
                    delete prev['whatsapp_no'];
                    return { ...prev };
                });
            }
        }

        if (orderAmc?.owner_ids) {
            if (!orderAmc?.owner_ids?.length) {
                setErrors((prev) => ({ ...prev, 'owner_ids': { message: validationMessages.ownerId.required } }));
                isError = true;
            } else {
                setErrors((prev) => {
                    delete prev['owner_ids'];
                    return { ...prev };
                });
            }
        }

        if (orderAmc?.pincode) {
            if (orderAmc?.pincode != "" && regExPattern?.pinCode && (!RegExp(regExPattern.pinCode).test(orderAmc.pincode))) {
                setErrors((prev) => ({ ...prev, 'pincode': { message: "Please provide valid pincode." } }));
                isError = true;

            } else {
                setErrors((prev) => {
                    delete prev['pincode'];
                    return { ...prev };
                });
            }
        }

        // handle errors for required fields
        if (!orderAmc?.order_id) {
            setErrors((prev) => ({ ...prev, 'offer_id': { message: validationMessages.offerName.required } }));
            isError = true;
        }
        if (!orderAmc?.amc_status) {
            setErrors((prev) => ({ ...prev, 'amc_status': { message: validationMessages.status.required } }));
            isError = true;
        }
        if (!orderAmc?.owner_ids?.length) {
            setErrors((prev) => ({ ...prev, 'owner_ids': { message: validationMessages.ownerId.required } }));
            isError = true;
        }
        if (!orderAmc?.phone) {
            setErrors((prev) => ({ ...prev, 'phone': { message: validationMessages.phone.required } }));
            isError = true;
        }

        return isError;
    };

    // onSubmit handler 
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('orderAmc', orderAmc);
        console.log('errors', errors);
        if (checkRequiredFields()) {
            setValidated(true);
            return;
        }
        console.log('orderAmc', orderAmc);
        console.log('errors', errors);

        if (Object?.keys(errors)?.length != 0) {
            setValidated(true);
            return;
        }
        const record = { ...orderAmc };
        // delete unnecessary fields
        delete record.owner_name;
        delete record.lead_name;
        delete record.offer_name_label;

        // handle numeric fields
        record.amc_total_amount = record?.amc_total_amount == '' ? 0 : record.amc_total_amount;
        record.billing_amount = record?.billing_amount == '' ? 0 : record.billing_amount;

        // handle date fields
        record.start_date = record?.start_date == '' ? null : record.start_date;
        record.end_date = record?.end_date == '' ? null : record.end_date;
        record.billing_date = record?.billing_date == '' ? null : record.billing_date;
        record.lost_date = record?.lost_date == '' ? null : record.lost_date;


        // Handle date fields
        if (record?.start_date) record.start_date = formatDate(record.start_date);
        if (record?.end_date) record.end_date = formatDate(record.end_date);
        if (record?.billing_date) record.billing_date = formatDate(record.billing_date);
        if (record?.lost_date) record.lost_date = formatDate(record.lost_date);
        // handel owner_ids  
        record.owner_ids = record.owner_ids?.filter((item) => (item.value))?.map((item) => item.value);
        // //========= Logic to perform Create or Edit ======
        if (record.id) {
            // console.log('Updated');
            const result = await fuziElevatorsApi.saveOrderAmc(record);
            if (result?.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Record Update",
                    message: "Record updated successfully",
                });
                // navigate(`/contacts/${record?.id}`, { state: record });
                navigate(`${ROUTES.ORDER_AMC.LIST}/${record?.id}`, { state: record });
            } else {
                PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Update Error', message: result?.errors });
            }
        } else {
            // console.log('Created');
            const result = await fuziElevatorsApi.createOrderAmc(record);
            if (result?.success) {
                PubSub.publish("RECORD_SAVED_TOAST", {
                    title: "Record created",
                    message: "Record created successfully",
                });
                navigate(`${ROUTES.ORDER_AMC.LIST}/${result.id}`, { state: result.data });
            } else {
                PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record Save Error', message: result?.errors });
            }
        }
    };

    const handleCancel = () => {
        if (orderAmc.id) {
            navigate(`${ROUTES.ORDER_AMC.LIST}/${orderAmc.id}`, { state: orderAmc });
        } else {
            navigate(ROUTES.ORDER_AMC.LIST);
        }
    };

    const onOrderAmcSelect = async (id) => {
        const orderData = await fuziElevatorsApi.fetchOrderById(id);
        console.log('orderData', orderData);
        if (orderData) {

            const orderAmcRecord = {};
            // General Info
            // orderAmcRecord.order_job_no = orderData?.job_no;
            orderAmcRecord.lead_id = orderData.lead_id || "";
            orderAmcRecord.lead_name = orderData.lead_name || "";

            orderAmcRecord.email = orderData.email || "";
            orderAmcRecord.phone = orderData.phone || "";
            orderAmcRecord.whatsapp_no = orderData.whatsapp_no || "";
            // orderAmcRecord.owner_ids = orderData.owner_ids || [];
            // orderAmcRecord.owner_name = orderData.owner_name || "";
            // Imran Khan Added on 07-04-2026 to handle owner_ids field to add Jitendra Choudhary and current login user as owner by default when order is selected for AMC creation
            const orderOwners = orderData.owner_ids || [];
            const currentUser = { value: userInfo?.id, label: userInfo?.username };

            const hasJitendra = orderOwners.some((o) => o.value === JITENDRA_USER.value);
            const hasCurrentUser = orderOwners.some((o) => o.value === currentUser.value);

            let finalOwners = [...orderOwners];
            if (!hasJitendra) finalOwners.push(JITENDRA_USER);
            if (!hasCurrentUser && currentUser.value !== JITENDRA_USER.value) {
            finalOwners.push(currentUser);
            }
            orderAmcRecord.owner_ids = finalOwners;

            // Customer Info 
            orderAmcRecord.customer_type = orderData.customer_type || "";
            orderAmcRecord.company_name = orderData.company_name || "";
            orderAmcRecord.sector = orderData.sector || "";
            orderAmcRecord.is_gst = orderData.gst_no && "Yes";
            orderAmcRecord.gst_no = orderData.gst_no || "";

            // Address Info
            orderAmcRecord.site_address = orderData.site_address || "";
            orderAmcRecord.state = orderData.state || "";
            orderAmcRecord.city = orderData.city || "";
            orderAmcRecord.office_address = orderData.office_address || "";
            orderAmcRecord.office_city = orderData.office_city || "";
            orderAmcRecord.pincode = orderData.pincode || "";
            orderAmcRecord.country = orderData.country || "";
            orderAmcRecord.area = orderData.area || "";//Add this field by shahir hussain 28-01-2026
            orderAmcRecord.segment = orderData.segment || "";//Added by shahir hussain for segment type field 02-02-2025

            if (orderData.phone) {
                setErrors((prev) => {
                    delete prev['phone'];
                    return { ...prev };
                });
            }
            if (orderData?.owner_ids) {
                setErrors((prev) => {
                    delete prev['owner_ids'];
                    return { ...prev };
                });
            }

            setOrderAmc((prev) => ({ ...prev, ...orderAmcRecord }));
        }
    };

    return (
        <Container className="pb-5">
            <Row>
                <Col md={12} className="sticky-breadcrumb">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>Home</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => navigate(ROUTES.ORDER_AMC.LIST)} >AMC's</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col md={12}>
                    <Form
                        className=""
                        onSubmit={() => handleSubmit}
                        noValidate
                        validated={validated}
                    >
                        <Card className="shadow">
                            <CardHeader className="bg-custom text-white sticky-card-header">
                                <Row className="w-100"  >
                                    <Col lg={6} className="" >
                                        <div className="d-flex align-items-center h-100 gap-3" >
                                            {orderAmc?.id ? (
                                                <h5 className="m-0">Edit AMC {orderAmc?.order_jon_no || ""}</h5>
                                            ) : (
                                                <h5 className="m-0">Create AMC</h5>
                                            )}
                                        </div>
                                    </Col>
                                    <Col lg={6} className="p-0" >
                                        <Stack direction="horizontal" className="float-end" gap={2}>
                                            <Button
                                                size="sm"
                                                className="btn-save"
                                                onClick={handleSubmit}>
                                                Save
                                            </Button>
                                            <Button
                                                size="sm"
                                                className="btn-delete"
                                                onClick={handleCancel}
                                            >
                                                Cancel
                                            </Button>
                                        </Stack>
                                    </Col>
                                </Row>
                            </CardHeader>

                            <CardBody className="">

                                <Row lg={12} className="view-form ">
                                    <>
                                        <Col lg={6}>
                                            <Form.Group
                                            >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicOffer"
                                                >
                                                    Order
                                                </Form.Label>
                                                <div className="d-flex align-items-center gap-2">
                                                    <div className="flex-grow-1">
                                                        <Select
                                                            required
                                                            className={`${orderAmc?.order_id ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                            placeholder="Select your order"
                                                            options={orders?.map((order) => ({ 'value': order?.id, 'label': order?.name }))}
                                                            onChange={(e) => {
                                                                handleChange({ target: { name: "order_id", 'value': e.value } });
                                                                handleChange({ target: { name: "offer_name_label", 'value': e.label } });
                                                                onOrderAmcSelect(e.value);
                                                            }}
                                                            value={orderAmc?.order_id ? { value: orderAmc?.order_id, label: orderAmc?.offer_name_label } : ""}
                                                        />
                                                    </div>
                                                    <Button
                                                        size="sm"
                                                        variant="success"
                                                        disabled={!orderAmc?.order_id}
                                                        onClick={() => orderAmc?.order_id && onOrderAmcSelect(orderAmc?.order_id)}
                                                        className="refresh-btn"
                                                    >
                                                        <i className="fa fa-refresh"></i>
                                                    </Button>
                                                </div>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.order_id?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicStateLead"
                                                >
                                                    Lead
                                                </Form.Label>
                                                <Select
                                                    placeholder="Select your lead"
                                                    options={leads?.map((lead) => ({ 'value': lead?.id, 'label': lead?.name }))}
                                                    onChange={(e) => {
                                                        handleChange({ target: { name: "lead_id", 'value': e.value } });
                                                        handleChange({ target: { name: "lead_name", 'value': e.label } });
                                                    }}
                                                    value={orderAmc?.lead_id ? { value: orderAmc?.lead_id, label: orderAmc?.lead_name } : ""}
                                                ></Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.lead_id?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicStatus"
                                                >
                                                    Status
                                                </Form.Label>
                                                <Form.Select
                                                    required
                                                    name="amc_status"
                                                    value={orderAmc?.amc_status || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">--select status--</option>
                                                    {Constant?.AMC_STATUS_VALUES?.sort((a, b) => a.sortorder > b.sortorder ? 1 : -1)?.map((value, index) => <option value={value.label} key={index}>{value.label}</option>)}

                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.amc_status?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicEmail"
                                                >
                                                    Email
                                                </Form.Label>
                                                <Form.Control
                                                    pattern={regExPattern.email}
                                                    type="email"
                                                    name="email"
                                                    placeholder="Enter email"
                                                    value={orderAmc?.email || ""}
                                                    onChange={handleChange}
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.email?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group  >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPhone"
                                                >
                                                    Phone
                                                </Form.Label>
                                                <Form.Control
                                                    required
                                                    type="text"
                                                    name="phone"
                                                    placeholder="Enter phone"
                                                    value={orderAmc?.phone || ""}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                    pattern={regExPattern.phone}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.phone?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group  >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPhone"
                                                >
                                                    WhatsApp No.
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="whatsapp_no"
                                                    placeholder="Enter whatsApp number"
                                                    value={orderAmc?.whatsapp_no || ""}
                                                    onChange={handleChange}
                                                    maxLength={10}
                                                    pattern={regExPattern.phone}
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.whatsapp_no?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {/* <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicOwner"
                                                >
                                                    Assign Staff
                                                </Form.Label>
                                                <Select
                                                    required
                                                    name="owner_id"
                                                    className={`${orderAmc?.owner_id ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                    onChange={(e) => {
                                                        handleChange({ target: { name: "owner_id", value: e.value } });
                                                        handleChange({ target: { name: "owner_name", value: e.label } });
                                                    }}
                                                    options={assignUsers?.map((user) => ({ value: user.id, label: user.username })) || []}
                                                    value={orderAmc?.owner_id ? { value: orderAmc?.owner_id || "", label: orderAmc?.owner_name || "" } : ""}
                                                />
                                                {(errors?.owner_id?.message && (!orderAmc.owner_id)) && <div className="feedback-invalid">
                                                    {errors?.owner_id?.message}
                                                </div>}
                                            </Form.Group>
                                        </Col> */}
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicLeadDelegatedUsers"
                                                >
                                                    Assign Users
                                                </Form.Label>
                                                <Select
                                                    isMulti
                                                    className={`${(Array.isArray(orderAmc?.owner_ids) && orderAmc?.owner_ids?.length > 0) ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                    placeholder="Select your Assign Staff"
                                                    options={assignUsers?.map((item) => ({ value: item.id, label: item.username })) || []}
                                                    value={orderAmc?.owner_ids?.filter((item) => (item.value))}
                                                    onChange={(e) => {
                                                        handleChange({
                                                            target: { name: "owner_ids", value: e },
                                                        });
                                                    }}
                                                />
                                                {(errors?.owner_ids?.message && validated) && <div className="feedback-invalid">
                                                    {errors?.owner_ids?.message}
                                                </div>}
                                            </Form.Group>
                                        </Col>
                                    </>

                                    <>
                                        <Col md={12} className="section-header">Customer Information</Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicCustomerType"
                                                >
                                                    Customer Type
                                                </Form.Label>
                                                <Form.Select
                                                    required
                                                    placeholder="Select Customer type"
                                                    aria-label="Select Customer type"
                                                    name="customer_type"
                                                    value={orderAmc?.customer_type || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">---Select---</option>
                                                    <option value="Individual">Individual</option>
                                                    <option value="Corporate">Corporate</option>

                                                </Form.Select>

                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.customer_type?.message}
                                                </Form.Control.Feedback>

                                            </Form.Group>
                                        </Col>
                                        {orderAmc?.customer_type === "Corporate" &&
                                            <Col lg={6}>
                                                <Form.Group >
                                                    <Form.Label
                                                        className="form-view-label"
                                                        htmlFor="formBasicCompanyName"
                                                    >
                                                        Company Name
                                                    </Form.Label>
                                                    <Form.Select
                                                        name="company_name"
                                                        placeholder="Enter company name"
                                                        value={orderAmc?.company_name || ""}
                                                        onChange={handleChange}
                                                    >
                                                        <option value="">---Select---</option>
                                                        {['Classic', 'ELevator', 'LR', 'Metro', 'Pranav', 'RS Associate']?.map((value, index) => <option value={value} key={index}>{value}</option>)}

                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors?.company_name?.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        }
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicSector "
                                                >
                                                    Sector
                                                </Form.Label>
                                                <Form.Select
                                                    name="sector"
                                                    value={orderAmc?.sector || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">---select sector---</option>
                                                    {["Government site", "Customer is private", "Government customer direct with us"].map((item, index) => <option value={item} key={index}>{item}</option>)}
                                                </Form.Select>

                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.sector?.message}
                                                </Form.Control.Feedback>

                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group
                                            >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicIsGst"
                                                >
                                                    Is GST Applicable
                                                </Form.Label>
                                                <FormSelect
                                                    name="is_gst"
                                                    value={orderAmc?.is_gst || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value={""}>--select--</option>
                                                    <option value={"Yes"}>Yes</option>
                                                    <option value={"No"}>No</option>
                                                </FormSelect>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.is_gst?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {orderAmc?.is_gst === 'Yes' && <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label>GST Number</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter gst number"
                                                    name="gst_no"
                                                    value={orderAmc?.gst_no || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        setOrderAmc(prev => ({
                                                            ...prev,
                                                            gst_no: value.replace(/\s+/g, "").toUpperCase()
                                                        }));
                                                    }}
                                                />
                                            </Form.Group>
                                            <Form.Control.Feedback type="invalid">
                                                {errors?.gst_no?.message}
                                            </Form.Control.Feedback>
                                        </Col>}
                                        {/* //Added by shahir hussain for segment type field 02-02-2025 */}
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label className="form-view-label">
                                                    Segment Type
                                                </Form.Label>

                                                <Select
                                                    isMulti
                                                    placeholder="Select Segment Type"
                                                    options={segmentOptions}
                                                    value={
                                                        typeof orderAmc?.segment === "string" && orderAmc?.segment
                                                            ? segmentOptions?.filter((opt) =>
                                                                orderAmc?.segment?.split(",").includes(opt?.value),
                                                            )
                                                            : []
                                                    }
                                                    onChange={(selectedOptions) => {
                                                        handleChange({
                                                            target: {
                                                                name: "segment",
                                                                value: selectedOptions,
                                                            },
                                                        });
                                                    }}
                                                //   className={
                                                //     orderAmc?.segment && orderAmc?.segment?.length > 0
                                                //       ? "custom-select-valid"
                                                //       : "custom-select-invalid"
                                                //   }
                                                />

                                                {errors?.segment?.message && validated && (
                                                    <div className="feedback-invalid">
                                                        {errors?.segment?.message}
                                                    </div>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </>

                                    <>
                                        <Col md={12} className="section-header">AMC Information</Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicAMCUpto"
                                                >
                                                    AMC Upto
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="amc_upto"
                                                    placeholder="Enter amc upto"
                                                    value={orderAmc?.amc_upto || ""}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.amc_upto?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicBillingName"
                                                >
                                                    Billing Name
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Enter billing name"
                                                    name="billing_name"
                                                    value={orderAmc?.billing_name || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.billing_name?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicBillingNumber"
                                                >
                                                    Billing Number
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Enter billing number"
                                                    name="billing_no"
                                                    value={orderAmc?.billing_no || ""}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.billing_no?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPeriod"
                                                >
                                                    Billing Date
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    placeholder="Enter billing date"
                                                    name="billing_date"
                                                    value={orderAmc?.billing_date ? formatDate(orderAmc.billing_date || "") : ''}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.billing_date?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicBillingAmount"
                                                >
                                                    Billing Amount
                                                </Form.Label>
                                                <Form.Control
                                                    type="number"
                                                    onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                    placeholder="Enter billing amount"
                                                    name="billing_amount"
                                                    value={orderAmc?.billing_amount || 0}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.billing_amount?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPartsType"
                                                >
                                                    Parts Type
                                                </Form.Label>
                                                <Form.Select
                                                    name="parts_type"
                                                    value={orderAmc?.parts_type || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">--select type--</option>
                                                    {['With Parts', 'Without Parts'].map((value, index) => <option value={value} key={index}>{value}</option>)}

                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.parts_type?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPeriod"
                                                >
                                                    Period
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Enter period"
                                                    name="period"
                                                    value={orderAmc?.period || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.period?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicStartDate"
                                                >
                                                    Start Date
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="start_date"
                                                    value={formatDate(orderAmc.start_date || "")}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.start_date?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicEndDate"
                                                >
                                                    Upto
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="end_date"
                                                    value={formatDate(orderAmc.end_date || "")}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.end_date?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PAYMENT].some(permission => {
                                            return userInfo?.permissions?.map(p => p.name).includes(permission);
                                        }) && (
                                                <>
                                                    <Col lg={6}>
                                                        <Form.Group >
                                                            <Form.Label
                                                                className="form-view-label"
                                                                htmlFor="formBasicAmcPrice"
                                                            >
                                                                Amc Price
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                placeholder="Enter amc price"
                                                                name="amc_total_amount"
                                                                value={orderAmc?.amc_total_amount || ""}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors?.amc_total_amount?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    {/* <Col lg={6}>
                                            <Form.Group
                                            >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicBasicAmountValue"
                                                >
                                                    Basic Amount Value
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Enter basic amount"
                                                    type="number"
                                                    onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                    name="basic_amount"
                                                    value={orderAmc?.basic_amount || ''}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.basic_amount?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col> */}
                                                    {/* New Fields Added As Per Client Requiment */}
                                                    <Col lg={6}>
                                                        <Form.Group
                                                        >
                                                            <Form.Label
                                                                className="form-view-label"
                                                                htmlFor="formBasicOrderDate"
                                                            >
                                                                Cheque Amount
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                name="cheque_amount"
                                                                placeholder="Enter cheque amount"
                                                                value={orderAmc?.cheque_amount || ''}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors?.cheque_amount?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Form.Group
                                                        >
                                                            <Form.Label
                                                                className="form-view-label"
                                                                htmlFor="formBasicOrderDate"
                                                            >
                                                                Cash Amount
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                name="cash_amount"
                                                                placeholder="Enter cash amount"
                                                                value={orderAmc?.cash_amount || ''}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors?.cheque_amount?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col lg={6}>
                                                        <Form.Group
                                                        >
                                                            <Form.Label
                                                                className="form-view-label"
                                                                htmlFor="formBasicTPC"
                                                            >
                                                                TPC
                                                            </Form.Label>
                                                            <Form.Control
                                                                placeholder="Enter tpc"
                                                                type="number"
                                                                onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                name="tpc_amount"
                                                                value={orderAmc?.tpc_amount || ''}
                                                                onChange={handleChange}
                                                            />
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors?.tpc_amount?.message}
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </>
                                            )}
                                        {/* End Here */}
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPaymentStatus"
                                                >
                                                    Payment Status
                                                </Form.Label>
                                                <Form.Select
                                                    name="payment_status"
                                                    value={orderAmc?.payment_status || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">--select status--</option>
                                                    {['Pending', 'Due', 'Paid', 'Not Paid'].map((value, index) => <option value={value} key={index}>{value}</option>)}

                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.payment_status?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPaymentMode"
                                                >
                                                    Payment Mode
                                                </Form.Label>
                                                <Form.Select
                                                    name="payment_mode"
                                                    value={orderAmc?.payment_mode || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">--select mode--</option>
                                                    {['Monthly', 'Quarterly', 'Half Yearly', 'Yearly', 'One Time'].map((value, index) => <option value={value} key={index}>{value}</option>)}

                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.payment_mode?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPaymentFrequency"
                                                >
                                                    Payment Frequency
                                                </Form.Label>
                                                <Form.Select
                                                    name="payment_frequency"
                                                    value={orderAmc?.payment_frequency || ""}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">--select frequency--</option>
                                                    {Constant?.PAYMENT_FREQUENCY_VALUES?.map((item, index) => <option value={item.value} key={index}>{item.label}</option>)}

                                                </Form.Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.payment_frequency?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </>

                                    <>
                                        <Col md={12} className="section-header">Address Information</Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicSiteAddress"
                                                >
                                                    Site Address
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="site_address"
                                                    placeholder="Enter site address"
                                                    value={orderAmc?.site_address || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.site_address?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        {/* //Added by shahir hussain */}
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicArea"
                                                >
                                                    Area
                                                </Form.Label>
                                                <Form.Control
                                                    pattern={regExPattern.name}
                                                    type="text"
                                                    name="area"
                                                    placeholder="Enter area name"
                                                    value={orderAmc?.area || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) =>
                                                        handleUppercaseChange(e, handleChange)
                                                    }
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.area?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicState"
                                                >
                                                    State
                                                </Form.Label>

                                                <Select
                                                    placeholder="Select your state"
                                                    options={states?.map((state) => ({
                                                        value: state,
                                                        label: state,
                                                    }))}
                                                    onChange={(e) => {
                                                        setOrderAmc((prev) => ({ ...prev, city: "" }));
                                                        handleChange({
                                                            target: { name: "state", value: e.value },
                                                        });
                                                    }}
                                                    value={
                                                        orderAmc?.state
                                                            ? {
                                                                value: orderAmc?.state || "",
                                                                label: orderAmc?.state || "",
                                                            }
                                                            : ""
                                                    }
                                                ></Select>
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.state?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicCity"
                                                >
                                                    City
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="city"
                                                    placeholder="Enter city"
                                                    value={orderAmc?.city || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.city?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicOfficeAddress"
                                                >
                                                    Office Address
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="office_address"
                                                    placeholder="Enter office address"
                                                    value={orderAmc?.office_address || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.office_address?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicOfficeCity"
                                                >
                                                    Office City
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="office_city"
                                                    placeholder="Enter office city"
                                                    value={orderAmc?.office_city || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.office_city?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicPin"
                                                >
                                                    Pincode
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="pincode"
                                                    placeholder="Enter pincode"
                                                    value={orderAmc?.pincode || ""}
                                                    onChange={handleChange}
                                                    pattern={regExPattern.pinCode}
                                                />

                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.pincode?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                        <Col lg={6}>
                                            <Form.Group  >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicCountry"
                                                >
                                                    Country
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="country"
                                                    placeholder="Enter country"
                                                    value={orderAmc?.country || ""}
                                                    // onChange={handleChange}
                                                    onChange={(e) => handleUppercaseChange(e, handleChange)}
                                                // pattern={regExPattern.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.country?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col>
                                    </>
                                </Row>
                            </CardBody>
                        </Card>
                    </Form>
                </Col>
            </Row >
            <Modal show={showLostModal} >
                <Modal.Header >
                    <Modal.Title>REASON OF AMC LOST</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Col lg={12}>
                        <Form.Group>
                            <Form.Label>Lost Date</Form.Label>
                            <Form.Control
                                disabled
                                value={formatDateForView(orderAmc.lost_date)}
                            />
                        </Form.Group>
                    </Col>
                    <Col lg={12}>
                        <Form.Group>
                            <Form.Label>Reason</Form.Label>
                            <Form.Control
                                type="text"
                                name="lost_remark"
                                placeholder="Enter reason"
                                value={orderAmc?.lost_remark || ""}
                                onChange={handleChange}
                            // pattern={regExPattern.name}
                            />
                        </Form.Group>
                    </Col>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="success" disabled={!orderAmc?.lost_remark} onClick={() => setShowLostModal(false)}>
                        Done
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container >

    );
};

export default OrderAmcEdit;